import createModule from "../createModule"
import view from "./view"
import { getDatacloudUrlGetter } from "selectors/urls"
import { getRole } from "helpers/permissions/roles"
import { getDatasetEntitlementsEnabled } from "modules/account-root/selectors"
import { getAccountDatasets, getBrowseDatasets } from "./selectors"
import { Creators } from "./model"
import withNavigate from "hocs/withNavigate"
import withOutletContext from "hocs/withOutletContext"

export default withNavigate(withOutletContext(createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "accountDatasets",
    as: null,
    url: ({ account }) => `/api/${account}/datacloud/datasets?showHidden=true`,
  },
  {
    resource: "datasets",
    as: null,
    url: ({ account }) => `/api/${account}/datacloud/all`,
  }],
  mapStateToProps: (state, props) => ({
    accountDatasets: getAccountDatasets(state, props),
    datasets: getBrowseDatasets(state, props),
    urlGetter: getDatacloudUrlGetter(state, props),
    role: getRole(state),
    entitlementsEnabled: getDatasetEntitlementsEnabled(state),
  }),
  actions: {
    ...Creators,
  },
})))
